import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import "../assets/css/Jumbotronc2.css";
import { Link } from "gatsby";

const altTextMap = {
  j2: "BBIS Commercial HVAC System Image 1",
  j3: "BBIS Commercial HVAC System Image 2",
  j4: "BBIS Luxury Home Hero Image",
  j5: "BBIS Sustainable Heating Panels",
  j6: "BBIS Energy-Efficient Swimming Pool",
  j7: "BBIS Smart Home Hero Banner",
  j8: "BBIS Air Conditioning System for Commercial Buildings",
  j9: "BBIS Renewable Bio Pellets Heating Solution",
  j10: "BBIS Sustainable Catering Facilities",
  j11: "BBIS Geothermal Energy Heating and Cooling",
  j12: "BBIS High-Efficiency Heat Pump Diagram",
  j13: "BBIS Eco-Friendly Laundry Services",
  j14: "BBIS Premium Hotel-Grade Towels",
  j15: "BBIS Smart Underfloor Heating System",
  j16: "BBIS High-Performance Boiler System",
  j17: "BBIS Advanced Plumbing and Pipes Infrastructure",
  j18: "BBIS Professional Commercial Boiler Repair Services",
  j19: "BBIS Powerflushing for Efficient Heating Systems",
};

export const Jumbotronv2 = ({ imgName, headingTag, descriptionTag, showOverlay }) => {
  const data = useStaticQuery(graphql`
    query {
      j2: file(relativePath: { eq: "Hero/bbis-commercial-1-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j3: file(relativePath: { eq: "Hero/bbis-commercial-2-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j4: file(relativePath: { eq: "Hero/bbis-hero-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j5: file(relativePath: { eq: "Hero/bbis-hero-panels.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j6: file(relativePath: { eq: "Hero/bbis-hero-pool.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j7: file(relativePath: { eq: "Hero/bbis-hero-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j8: file(relativePath: { eq: "Hero/bbis-air-conditioning-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j9: file(relativePath: { eq: "Hero/bbis-bio-pellets-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j10: file(relativePath: { eq: "Hero/bbis-catering-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j11: file(relativePath: { eq: "Hero/bbis-geo-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j12: file(relativePath: { eq: "Hero/BBIS-heat-pump-diagram-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j13: file(relativePath: { eq: "Hero/bbis-laundry-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j14: file(relativePath: { eq: "Hero/BBIS-Towels-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j15: file(relativePath: { eq: "Hero/bbis-underfloor-heating-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j16: file(relativePath: { eq: "Hero/bbis-boiler.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j17: file(relativePath: { eq: "Hero/bbis-pipes.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j18: file(
        relativePath: { eq: "Hero/bbis-commercial-boiler-repair.jpeg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      j19: file(relativePath: { eq: "Hero/bbis-powerflushing.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
              j20: file(relativePath: { eq: "Hero/bbis-powerflushing.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
                      j21: file(relativePath: { eq: "Hero/bbis-bio-pellets-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
        j22: file(relativePath: { eq: "Hero/BBIS-heat-pump-diagram-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 945) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `);

  return (
<div className="mx-auto d-block img-fluid" style={{ position: "relative" }}>
  <Img
    className="mx-auto img-fluid d-block"
    fluid={data[imgName]?.childImageSharp.fluid}
    alt={altTextMap[imgName] || "BBIS Image"}
  />

  {showOverlay && (
    <div className="mx-auto overlay">
      <div className="cta-jumbotron">
        <h1 className="p-1 jfsh">{headingTag}</h1>
        <p className="p-1 lead jfs">{descriptionTag}</p>
        <Link className="btn btn-primary btn-sm mt-1 jfs" to="/contact/">Get a Free Quote</Link>
      </div>
    </div>
  )}
</div>
    
    
  );
};




